import { gql } from '@apollo/client/core'

export const LOGIN_MUTATION = gql`
  mutation Login($data: LoginInput!) {
    login(data: $data) {
      accessToken
      tokenType
      expiresIn
      refreshToken
    }
  }
`

export const REGISTER_MUTATION = gql`
  mutation Register($data: RegisterInput!) {
    register(data: $data) {
      id
      email
      role
    }
  }
`

export const CREATE_ROOM_MUTATION = gql`
  mutation CreateRoom($data: CreateRoomInput!) {
    createRoom(data: $data) {
      slug
      name
      childName
      endAt
      status
      visits
    }
  }
`

export const START_PAINTING_MUTATION = gql`
  mutation StartPainting($data: StartPaintingInput!) {
    startPaintingChallenge(data: $data) {
      topic
      ageGroup
      steps { instruction hint rewardMessage }
      finalMessage
    }
  }
`

export const SUBMIT_PAINTING_MUTATION = gql`
  mutation SubmitPainting($data: SubmitPaintingInput!) {
    submitPainting(data: $data) {
      positiveFeedback
      analysisSummary
      tags
    }
  }
`

export const SUBMIT_PUZZLE_MUTATION = gql`
  mutation SubmitPuzzle($data: SubmitPuzzleInput!) {
    submitPuzzleSession(data: $data) { ok sessionId }
  }
`

export const UPLOAD_PUZZLE_IMAGES = gql`
  mutation UploadPuzzleImages($data: UploadPuzzleImagesInput!) {
    uploadPuzzleImages(data: $data) { ok sessionId }
  }
`

export const SUBMIT_SHAPES_MUTATION = gql`
  mutation SubmitShapes($data: SubmitShapesInput!) {
    submitShapesSession(data: $data) { ok sessionId }
  }
`

export const START_STORY_MUTATION = gql`
  mutation StartStory($data: StartStoryInput!) {
    startStorySession(data: $data) { ok sessionId title }
  }
`

export const APPEND_STORY_MESSAGE_MUTATION = gql`
  mutation AppendStoryMessage($data: AppendStoryMessageInput!) {
    appendStoryMessage(data: $data) { ok sessionId }
  }
`

export const STORY_ASK_MUTATION = gql`
  mutation StoryAsk($data: StoryAskInput!) {
    storyAsk(data: $data) { ok sessionId reply title }
  }
`

export const ANALYZE_STORY_MUTATION = gql`
  mutation AnalyzeStory($data: AnalyzeStoryInput!) {
    analyzeStorySession(data: $data) { ok sessionId }
  }
`

export const SUBMIT_LETTERS_MUTATION = gql`
  mutation SubmitLetters($data: SubmitLettersInput!) {
    submitLettersSession(data: $data) { ok sessionId }
  }
`

export const SUBMIT_MUSIC_MUTATION = gql`
  mutation SubmitMusic($data: SubmitMusicInput!) {
    submitMusicSession(data: $data) { ok sessionId }
  }
`

export const GENERATE_MUSIC_LYRICS_MUTATION = gql`
  mutation GenerateMusicLyrics($data: GenerateMusicLyricsInput!) {
    generateMusicLyrics(data: $data) { lyrics }
  }
`

export const GET_LETTER_EXAMPLE_MUTATION = gql`
  mutation GetLetterExample($data: GetLetterExampleInput!) {
    getLetterExample(data: $data) {
      exampleWord
      questions
      sessionId
    }
  }
`

export const ANSWER_LETTER_QUESTION_MUTATION = gql`
  mutation AnswerLetterQuestion($data: AnswerLetterQuestionInput!) {
    answerLetterQuestion(data: $data) {
      ok
      completed
    }
  }
`

export const GENERATE_LETTER_IMAGE_MUTATION = gql`
  mutation GenerateLetterImage($data: GenerateLetterImageInput!) {
    generateLetterImage(data: $data) {
      ok
      imageUrl
    }
  }
`
export const START_CONNECTION_MUTATION = gql`
  mutation StartConnection($data: StartConnectionInput!) {
    startConnectionMission(data: $data) { ok sessionId }
  }
`
export const UPLOAD_CONNECTION_STEP_MUTATION = gql`
  mutation UploadConnectionStep($data: UploadConnectionStepInput!) {
    uploadConnectionStep(data: $data) { ok sessionId }
  }
`
export const COMPLETE_CONNECTION_MUTATION = gql`
  mutation CompleteConnection($sessionId: String!) {
    completeConnectionMission(sessionId: $sessionId) {
      ok
      analysis {
        magicTitle
        powerScore
        funnyCaption
        badges
        superheroName
      }
    }
  }
`
